<template>
  <div v-if="$data.isReady" :style="bgStyle" style="min-height: 100vh">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { loadLanguageAsync } from '../api/i18n-setup'
import feathersClient from '../api/feathers-client'
import axios from 'axios'
import moment from 'moment'
import $config from '@/config'
import 'moment/locale/tr'
import * as Cookies from 'tiny-cookie'
import Navbar from '@/components/Navbar.vue'
export default {
  components: {
    Navbar
  },
  data() {
    return {
      isReady: false,
      formItem: {},
      bgStyle: null,
      wc: null
    }
  },

  computed: {
    ...mapGetters('current', {
      current: 'get'
    }),
    webcast() {
      return this.current('webcast')
    },
    ...mapGetters('page-settings', {
      pageSettings: 'getCopy'
    }),
    /*
    ...mapGetters("webcast", {
      webcast: "getCopy",
      webcastInStore: "get"
    }),
  */

    shortLink() {
      return this.$router.currentRoute.params.shortLink
    }
  },
  methods: {
    ...mapActions('current', {
      setCurrent: 'set'
    }),
    ...mapActions('authentication', {
      createAuth: 'create'
    }),
    ...mapActions('auth', ['authenticate']),
    ...mapGetters('registrations', {
      registration: 'getCopy'
    }),
    ...mapActions('webcast', {
      findWebcast: 'find',
      getWebcast: 'get'
    }),
    ...mapActions('stream', {
      getStreams: 'find'
    }),
    ...mapActions('page-settings', {
      getPageSettings: 'find'
    }),
    ...mapActions('appsettings', {
      getAppSettings: 'find'
    }),
    ...mapActions('registrations', {
      initUserAction: 'initUser'
    }),
    ...mapActions('devices', {
      initDeviceAction: 'initDevice'
    }),
    async initUserParams(wc) {
      let userParams = {
        webcastId: wc._id,
        isAnonymous: true
      }

      if (
        _.size(this.$router.currentRoute.query) > 0 &&
        this.$router.currentRoute.query.session
      ) {
        Cookies.set(this.webcast._id, this.$router.currentRoute.query.session)
      }

      if (
        _.size(this.$router.currentRoute.query) > 0 &&
        this.$router.currentRoute.query.uid
      ) {
        userParams['info'] = {}
        userParams['isAnonymous'] = false
        userParams['uid'] = this.$router.currentRoute.query.uid
        userParams['name'] = this.$router.currentRoute.query.name
        _.forEach(this.$router.currentRoute.query, (value, key) => {
          userParams['info'][key] = value
        })
      }

      if (
        _.size(this.$router.currentRoute.query) > 0 &&
        this.$router.currentRoute.query.e
      ) {
        userParams['info'] = {}
        userParams['isAnonymous'] = false
        let resolveURL =
          $config.feathersServer +
          '/resolveuser?e=' +
          decodeURI(this.$router.currentRoute.query.e) +
          '&t=' +
          decodeURI(this.$router.currentRoute.query.t)
        await axios.get(resolveURL).then(resp => {
          userParams['info']['email'] = resp.data['email']
          userParams['info']['name'] = resp.data['name']
          userParams['uid'] = resp.data['email']
          userParams['name'] = resp.data['name']
        })
      }

      if (
        _.size(this.$router.currentRoute.query) > 0 &&
        this.$router.currentRoute.query.t
      ) {
        userParams['token'] = this.$router.currentRoute.query.t
      }

      if (
        _.size(this.$router.currentRoute.query) == 1 &&
        this.$router.currentRoute.query.streamId
      ) {
        userParams['isAnonymous'] = true
      }

      return userParams
    },
    async init() {
      let wc = null

      await this.getAppSettings({ query: {} }).then(settings => {
        this.$store.commit('appsettings/setCurrent', settings.data[0])
      })

      await this.findWebcast({
        query: {
          shortLink: this.$router.currentRoute.params.shortLink
        }
      }).then(webcast => {
        if (webcast.total == 0) {
          this.$router.push('//404')
        } else {
          wc = webcast.data[0]
          if (wc.interfaceLang) {
            loadLanguageAsync(wc.interfaceLang)
            moment.locale(wc.interfaceLang)
          } else {
            loadLanguageAsync('en')
          }
          document.title = wc.title

          this.$store.commit('webcast/setCurrent', webcast.data[0])
        }
      })

      await this.setCurrent({
        service: 'webcast',
        id: wc._id
      })

      await this.initDeviceAction().then(device => {})

      await this.getPageSettings({
        query: { webcastId: wc._id }
      }).then(pageSettings => {
        this.$store.commit('page-settings/setCurrent', pageSettings.data[0])
      })

      /* Check referrer*/
      if (
        this.pageSettings.referrerDomainWhiteListEnabled &&
        this.$router.currentRoute.name != 'speaker'
      ) {
        function getHostName(url) {
          var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i)
          if (
            match != null &&
            match.length > 2 &&
            typeof match[2] === 'string' &&
            match[2].length > 0
          ) {
            return match[2]
          } else {
            return null
          }
        }
        let wl_array = this.pageSettings.referrerDomainWhiteList.split(',')
        let hn = getHostName(document.referrer)
        if (!_.includes(wl_array, hn)) {
          this.$router.push('/403')
          return false
        }
      }

      await this.getStreams({
        query: { webcastId: wc._id }
      }).then(streams => {
        this.$store.commit('stream/setCurrent', streams.data[0])
      })

      await this.initUserParams(wc).then(userParams => {
        let currentRoute = this.$router.currentRoute.name

        this.initUserAction(userParams).then(response => {
          if (userParams.token && !response) {
            this.$router.push('/403')
            return
          }
          console.log(response)
          if (response && currentRoute == 'landing') {
            if (wc.hasAudioRoom) {
              this.$router.push('/' + wc.shortLink + '/webinar/')
            } else {
              this.$router.push('/' + wc.shortLink + '/live/')
            }
          } else if (
            this.$store.state['page-settings'].copy.registrationEnabled &&
            !this.registration()
          ) {
            if (
              currentRoute != 'register' &&
              currentRoute != 'landing' &&
              currentRoute != 'speaker' &&
              currentRoute != 'embed'
            ) {
              this.$router.replace('/' + wc.shortLink + '/landing')
            }
          }
          this.updateBgStyle()
          this.$set(this.$data, 'isReady', true)
        })
      })

      return true
    },
    updateBgStyle() {
      let style = null
      if (this.pageSettings.bgImgUrl) {
        style = {
          'background-image': "url('" + this.pageSettings.bgImgUrl + "')",
          'background-repeat': ' no-repeat',
          'background-size': 'cover',
          'background-position-x': 'center',
          'background-position-y': 'top',
          'background-attachment': 'fixed'
        }
        if (this.pageSettings.bgImgPosition == 'left') {
          style['background-position-x'] = 'left'
        }
      }

      /* a fix for a special event */
      let shortLink = this.$router.currentRoute.params.shortLink
      if (
        shortLink == 'kardiyolojinobelleri' &&
        this.$router.currentRoute.name == 'live'
      ) {
        style = {
          'background-image': "url('/img/nobel_sahne.jpg')",
          'background-repeat': ' no-repeat',
          'background-size': 'contain',
          'background-position-x': 'center',
          'background-position-y': 'top',
          width: '100vw',
          height: '55vw',
          margin: 'auto'
        }
      }

      if (
        shortLink == '25aralikkardiyolojigundemi' &&
        this.$router.currentRoute.name == 'live'
      ) {
        style = {
          'background-image': "url('/img/25aralikkardiyolojigundemi.jpg')",
          'background-repeat': ' no-repeat',
          'background-size': 'contain',
          'background-position-x': 'center',
          'background-position-y': 'top',
          width: '100vw',
          height: '55vw',
          margin: 'auto'
        }
      }

      if (
        shortLink == 'diyabet360' &&
        this.$router.currentRoute.name == 'live'
      ) {
        style = {
          'background-image': "url('/img/diyabet360.jpg')",
          'background-repeat': ' no-repeat',
          'background-size': 'contain',
          'background-position-x': 'center',
          'background-position-y': 'top',
          width: '100vw',
          height: '55vw',
          margin: 'auto'
        }
      }

      this.bgStyle = style
    }
  },

  watch: {
    webcast() {
      console.log(webcast)
      console.log('webcast loaded')
    },
    webcastStatus(s) {
      console.log(s)
    },
    $route(to, from) {
      this.updateBgStyle()
    }
  },
  created() {
    let self = this
    this.init()

    feathersClient.io.on('disconnect', function() {
      console.log('disconnected')
    })

    feathersClient.io.on('connect', function() {
      /* if we loose socket conncetion during watch sent to stream session-connection data to new socket connection after re-connect*/
      if (feathersClient.subscribe) {
        feathersClient.io.emit('subscribe', feathersClient.subscribe)
      }

      /* Reload webcast and qna data */
      if (self.webcast) {
        self
          .findWebcast({
            query: {
              shortLink: self.$router.currentRoute.params.shortLink
            }
          })
          .then(wc => {
            self.getWebcast(wc.data[0]._id).then(wc => {
              self.$store.commit('webcast/setCurrent', wc)
              self.setCurrent({
                service: 'webcast',
                id: wc._id
              })
            })
          })
      }
    })

    if (self.$router.currentRoute.params.shortLink == 'emcletstalk') {
      ;(function(d, w, c) {
        w.ChatraID = 'WGfvwJdcAB7gZJExM'
        var s = d.createElement('script')
        w[c] =
          w[c] ||
          function() {
            ;(w[c].q = w[c].q || []).push(arguments)
          }
        s.async = true
        s.src = 'https://call.chatra.io/chatra.js'
        if (d.head) d.head.appendChild(s)
      })(document, window, 'Chatra')
    }
  }
}
</script>

<style>
</style>
